import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { Inbox } from "lucide-react";
import { api } from "@/lib/api";
import { EmptyState } from "@/components/common/Bits";
import TicketList from "@/components/tickets/TicketList";
import TicketDetail from "@/components/tickets/TicketDetail";

export default function Tickets() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [filters, setFilters] = useState({ status: "active", channel_id: "all", assignee: "all", q: "", tag: "" });
  const params = {
    status: filters.status === "all" ? undefined : filters.status,
    channel_id: filters.channel_id === "all" ? undefined : filters.channel_id,
    assignee: filters.assignee === "all" ? undefined : filters.assignee,
    q: filters.q || undefined,
    tag: filters.tag || undefined,
  };
  const { data, isLoading } = useQuery({ queryKey: ["tickets", params], queryFn: () => api.get("/tickets", { params }).then((r) => r.data), refetchInterval: 15000 });

  return (
    <div className="flex h-full">
      <TicketList tickets={data?.items || []} total={data?.total || 0} loading={isLoading} filters={filters} setFilters={setFilters} selectedId={id}
        onSelect={(t) => navigate(`/tickets/${t.id}`)} className={id ? "hidden" : "flex"} />
      <div className={`min-w-0 flex-1 ${id ? "flex" : "hidden lg:flex"} flex-col`} data-testid="ticket-focus-pane" data-focused={id ? "true" : undefined}>
        {id ? <TicketDetail id={id} onBack={() => navigate("/tickets")} /> : (
          <EmptyState icon={Inbox} title="Select a ticket" hint="Pick a ticket from the list to see its full email, attachments, timing and history." testId="ticket-empty-state" />
        )}
      </div>
    </div>
  );
}
